import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js/instance/some";
var invalidKeys = ['wedding_date', 'engagement_date', 'number_of_guests', 'budget', 'budget_value', 'themes', 'colors'];
export default function validatePayload(payload) {
  var _context;
  var weddingAddress = payload.addresses && _findInstanceProperty(_context = payload.addresses).call(_context, function (a) {
    return a.address_type === 'wedding';
  });
  var includesInvalidKeys = _someInstanceProperty(invalidKeys).call(invalidKeys, function (key) {
    return Object.prototype.hasOwnProperty.call(payload, key);
  });
  if (weddingAddress || includesInvalidKeys) {
    throw new Error('Wedding related attributes should be passed to the Wedding API. See. http://api-docs.eng.xogrp.com/details/production-wedding-api.');
  }
}